// Components==============
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './Search.module.scss';
// =========================

export default function Search({
  value,
  setValue,
  fluid,
}: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  fluid?: boolean;
}) {
  const translate = useTranslate();

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setValue(e.target.value);
  }

  return (
    <div styleName="container" style={{ width: fluid ? '100%' : '' }}>
      <input
        value={value}
        onChange={handleChange}
        type="text"
        styleName="input"
        placeholder={
          translate('filters.search-bar.search-placeholder') as string
        }
      />
      <FontAwesomeIcon icon={faSearch} />
    </div>
  );
}
